import { IconButton } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
type StyleProps = Readonly<{
    isSecondIcon: boolean
}>

const useStyles = makeStyles<StyleProps>()((theme, { isSecondIcon }) => ({
    iconButton: {
        gap: ".5rem",
        minWidth: "2.5rem",
        minHeight: "2.5rem",
        padding: isSecondIcon ? ".625rem 1rem" : ".625rem",
        borderRadius: ".75rem",
        color: theme.palette.common.black,
        boxShadow: "0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
        border: `1px solid ${theme.palette.tailwind.slate[300]}`,
    },
}))

type ActionButtonProps = {
    icon: IconProp
    secondIcon?: IconProp
    handleButtonClick: (event: React.MouseEvent<HTMLButtonElement>) => void
    updateClassName?: string
    disabled?: boolean
}

export const ActionButton = ({
    icon,
    secondIcon,
    handleButtonClick,
    updateClassName,
    disabled = false,
}: ActionButtonProps) => {
    const { classes, cx } = useStyles({ isSecondIcon: !!secondIcon })

    return (
        <IconButton
            onClick={handleButtonClick}
            className={cx(classes.iconButton, updateClassName)}
            size="small"
            disabled={disabled}
        >
            <FontAwesomeIcon icon={icon} />
            {secondIcon && <FontAwesomeIcon icon={secondIcon} />}
        </IconButton>
    )
}
